export const PERMISSIONS = {
  read: 'read',
  write: 'read/write'
};

export const MANAGE_LIBRARY_OPTIONS = {
  manage: 'manage',
  share: 'share'
};
